import React, { useEffect, useState } from "react";
function pad(n: number): string {
  return n.toString().padStart(2, "0");
}
export function Countdown() {
  // Persist a target 24h from first visit so the timer feels real per session.
  const [remaining, setRemaining] = useState<number>(() => {
    const total = 24 * 60 * 60;
    return total - (23 * 60 * 60 + 59 * 60 + 43) === 0 ? total : 23 * 3600 + 59 * 60 + 43;
  });
  useEffect(() => {
    const id = setInterval(() => {
      setRemaining(prev => prev <= 0 ? 0 : prev - 1);
    }, 1000);
    return () => clearInterval(id);
  }, []);
  const hrs = Math.floor(remaining / 3600);
  const mins = Math.floor(remaining % 3600 / 60);
  const secs = remaining % 60;
  const boxes = [{
    v: pad(hrs),
    l: "HS"
  }, {
    v: pad(mins),
    l: "MIN"
  }, {
    v: pad(secs),
    l: "SEG"
  }];
  return <div className="flex items-center justify-center gap-2 sm:gap-4" role="timer" aria-live="off" data-id="element-15" data-mp="10cv0y570u9f3">
      {boxes.map((b, i) => <React.Fragment key={b.l} data-id="element-16" data-mp="159bz7s7xq45w" data-mpi={i}>
          <div className="flex flex-col items-center" data-id="element-17" data-mp="y0n2ls8ibfc5">
            <div className="bg-black border-2 border-[#e10600] rounded-lg w-16 sm:w-20 py-2 sm:py-3 glow-red" data-id="element-18" data-mp="xzc1y1acynp9">
              <span className="font-display text-3xl sm:text-4xl text-white tabular-nums" data-id="element-19" data-mp="t095344j7nsd">{b.v}</span>
            </div>
            <span className="font-condensed text-[#e10600] text-sm mt-1 tracking-widest" data-id="element-20" data-mp="12s53yhefzhxn">{b.l}</span>
          </div>
          {i < boxes.length - 1 && <span className="font-display text-2xl sm:text-3xl text-[#e10600] -mt-4" data-id="element-21" data-mp="f33podixhckg">:</span>}
        </React.Fragment>)}
    </div>;
}